import getApiInstance from '../common/apiInstance';
import type { DeviceSettingsPayload } from './collectDeviceSettings';

const deviceSettingsApi = getApiInstance('/device-settings', 'no-device-settings');

export async function recordDeviceSettings(
  payload: DeviceSettingsPayload,
): Promise<void> {
  await deviceSettingsApi.post('/record', payload, {
    skipGlobalErrorToast: true,
    skipAuthRedirect: true,
  });
}
